import {
    DEFAULT_PLAYBACK_SKIP_BACKWARD_SECONDS,
    DEFAULT_PLAYBACK_SKIP_FORWARD_SECONDS,
    PLAYBACK_SKIP_BACKWARD_SECONDS_V1,
    PLAYBACK_SKIP_FORWARD_SECONDS_V1,
    PLAYBACK_SKIP_INTERVAL_OPTIONS,
} from '../constants/local_storage_constants';

const defaultStorage = () => {
    try {
        return window.localStorage;
    } catch (_) {
        return null;
    }
};

const normalizedInterval = (value, fallback) => {
    const interval = Number(value);
    return PLAYBACK_SKIP_INTERVAL_OPTIONS.includes(interval) ? interval : fallback;
};

const readInterval = (storage, key, fallback) => {
    try {
        return normalizedInterval(storage?.getItem(key), fallback);
    } catch (_) {
        return fallback;
    }
};

const persistInterval = (storage, key, value, fallback) => {
    const interval = normalizedInterval(value, fallback);
    try {
        storage?.setItem(key, String(interval));
    } catch (_) {
        // The selected interval remains usable in memory when storage is unavailable.
    }
    return interval;
};

export const readPlaybackSkipSettings = (storage = defaultStorage()) => ({
    backwardSeconds: readInterval(
        storage,
        PLAYBACK_SKIP_BACKWARD_SECONDS_V1,
        DEFAULT_PLAYBACK_SKIP_BACKWARD_SECONDS,
    ),
    forwardSeconds: readInterval(
        storage,
        PLAYBACK_SKIP_FORWARD_SECONDS_V1,
        DEFAULT_PLAYBACK_SKIP_FORWARD_SECONDS,
    ),
});

export const playbackSkipSettingsSummary = ({
    backwardSeconds,
    forwardSeconds,
}) => `−${backwardSeconds}s / +${forwardSeconds}s`;

export const playbackSkipSettingsAccessibilityValue = ({
    backwardSeconds,
    forwardSeconds,
}) => `${backwardSeconds} seconds back, ${forwardSeconds} seconds forward`;

export const persistPlaybackSkipBackwardSeconds = (
    value,
    storage = defaultStorage(),
) => persistInterval(
    storage,
    PLAYBACK_SKIP_BACKWARD_SECONDS_V1,
    value,
    DEFAULT_PLAYBACK_SKIP_BACKWARD_SECONDS,
);

export const persistPlaybackSkipForwardSeconds = (
    value,
    storage = defaultStorage(),
) => persistInterval(
    storage,
    PLAYBACK_SKIP_FORWARD_SECONDS_V1,
    value,
    DEFAULT_PLAYBACK_SKIP_FORWARD_SECONDS,
);

export const restoreDefaultPlaybackSkipSettings = (storage = defaultStorage()) => ({
    backwardSeconds: persistPlaybackSkipBackwardSeconds(
        DEFAULT_PLAYBACK_SKIP_BACKWARD_SECONDS,
        storage,
    ),
    forwardSeconds: persistPlaybackSkipForwardSeconds(
        DEFAULT_PLAYBACK_SKIP_FORWARD_SECONDS,
        storage,
    ),
});
